import { Switch as MantineSwitch, SwitchProps } from "@mantine/core"
import { forwardRef } from "react"

import { buildLabel } from "../utils"

export interface CustomSwitchProps extends Omit<SwitchProps, "onChange"> {
  onChange?: (checked: boolean) => void
  label?: string
  description?: string
  error?: string
  required?: boolean
  isLoading?: boolean
}

export const Switch = forwardRef<HTMLInputElement, CustomSwitchProps>(
  ({ onChange, error, label, required, isLoading, ...props }, ref) => {
    const finalLabel = buildLabel(label, isLoading, required)
    return (
      <MantineSwitch
        ref={ref}
        label={finalLabel}
        onChange={(event) => onChange?.(event.currentTarget.checked)}
        error={error}
        {...props}
      />
    )
  }
)

Switch.displayName = "Switch"
